import { render, staticRenderFns } from "./BackToLandingPageLink.vue?vue&type=template&id=2a61131e"
import script from "./BackToLandingPageLink.vue?vue&type=script&lang=js"
export * from "./BackToLandingPageLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports